!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("Stories", ["React"], t) : "object" == typeof exports ? exports.Stories = t(require("react")) : e.Stories = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 7);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialContext = void 0;
    var o = r(n(0));
    t.initialContext = {
      defaultInterval: 4e3,
      width: 360,
      height: 640
    };
    var i = o.default.createContext(t.initialContext);
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialContext = void 0;
    var o = r(n(0));
    t.initialContext = {
      stories: []
    };
    var i = o.default.createContext(t.initialContext);
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0));
    t.default = o.default.createContext({
      currentId: 0,
      videoDuration: 0,
      bufferAction: !1,
      pause: !1,
      next: function next() {}
    });
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = o(n(0)),
        a = o(n(19));

    t.default = function (e) {
      var t = e.story,
          n = e.globalHeader,
          o = e.children;
      return i.default.createElement(i.default.Fragment, null, o, t.header && i.default.createElement("div", {
        style: {
          position: "absolute",
          left: 12,
          top: 20,
          zIndex: 19
        }
      }, "object" === r(t) ? n ? n(t.header) : i.default.createElement(a.default, {
        heading: t.header.heading,
        subheading: t.header.subheading,
        profileImage: t.header.profileImage
      }) : null));
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function o(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        u = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && i(t, e, n);
      }
      return a(t, e), t;
    },
        l = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = u(n(0)),
        f = l(n(20));

    t.default = function (e) {
      var t = e.story,
          n = e.action,
          o = e.customCollapsed,
          i = e.children,
          a = r(c.useState(!1), 2),
          u = a[0],
          l = a[1],
          s = f.default;
      return c.default.createElement(c.default.Fragment, null, i, t.seeMore && c.default.createElement("div", {
        style: {
          position: "absolute",
          margin: "auto",
          bottom: u ? "unset" : 0,
          zIndex: 9999,
          width: "100%",
          height: u ? "100%" : "auto"
        }
      }, c.default.createElement(s, {
        action: n,
        toggleMore: function toggleMore(e) {
          n(e ? "pause" : "play"), l(e);
        },
        showContent: u,
        seeMoreContent: t.seeMore,
        customCollapsed: o || t.seeMoreCollapsed
      })));
    };
  }, function (e, t, n) {
    var r = n(16),
        o = n(17);
    "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    r(o, i);
    e.exports = o.locals || {};
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function o(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return i(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        u = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        l = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && a(t, e, n);
      }
      return u(t, e), t;
    },
        c = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WithSeeMore = t.WithHeader = void 0;

    var f = l(n(0)),
        s = c(n(8)),
        d = c(n(1)),
        y = c(n(2)),
        p = n(13),
        h = n(14),
        m = c(n(4)),
        v = c(n(5)),
        b = function b(e) {
      var t = e.renderers ? e.renderers.concat(h.renderers) : h.renderers,
          n = {
        width: e.width,
        height: e.height,
        loader: e.loader,
        header: e.header,
        storyStyles: e.storyStyles,
        loop: e.loop,
        defaultInterval: e.defaultInterval,
        isPaused: e.isPaused,
        currentIndex: e.currentIndex,
        onStoryStart: e.onStoryStart,
        onStoryEnd: e.onStoryEnd,
        onAllStoriesEnd: e.onAllStoriesEnd,
        keyboardNavigation: e.keyboardNavigation
      },
          r = o(f.useState({
        stories: g(e.stories, t)
      }), 2),
          i = r[0],
          a = r[1];
      return f.useEffect(function () {
        a({
          stories: g(e.stories, t)
        });
      }, [e.stories, e.renderers]), f.default.createElement(d.default.Provider, {
        value: n
      }, f.default.createElement(y.default.Provider, {
        value: i
      }, f.default.createElement(s.default, null)));
    },
        g = function g(e, t) {
      return e.map(function (e) {
        var n = {};
        "string" == typeof e ? (n.url = e, n.type = "image") : "object" === r(e) && (n = Object.assign(n, e));
        var o = p.getRenderer(n, t);
        return n.originalContent = n.content, n.content = o, n;
      });
    };

    b.defaultProps = {
      width: 360,
      height: 640,
      defaultInterval: 4e3
    }, t.WithHeader = m.default, t.WithSeeMore = v.default, t.default = b;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function o(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        u = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && i(t, e, n);
      }
      return a(t, e), t;
    },
        l = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = u(n(0)),
        f = l(n(1)),
        s = l(n(2)),
        d = l(n(3)),
        y = l(n(9)),
        p = l(n(10));

    t.default = function () {
      var e = r(c.useState(0), 2),
          t = e[0],
          n = e[1],
          o = r(c.useState(!0), 2),
          i = o[0],
          a = o[1],
          u = r(c.useState(!0), 2),
          l = u[0],
          m = u[1],
          v = r(c.useState(0), 2),
          b = v[0],
          g = v[1],
          _ = c.useRef(),
          j = c.useContext(f.default),
          O = j.width,
          w = j.height,
          S = j.loop,
          x = j.currentIndex,
          M = j.isPaused,
          E = j.keyboardNavigation,
          P = c.useContext(s.default).stories;

      c.useEffect(function () {
        "number" == typeof x && (x >= 0 && x < P.length ? A(function () {
          return x;
        }) : console.error("Index out of bounds. Current index was set to value more than the length of stories array.", x));
      }, [x]), c.useEffect(function () {
        "boolean" == typeof M && a(M);
      }, [M]), c.useEffect(function () {
        if ("undefined" != typeof window && window.document && "boolean" == typeof E && E) return document.addEventListener("keydown", C), function () {
          document.removeEventListener("keydown", C);
        };
      }, [E]);

      var C = function C(e) {
        "ArrowLeft" === e.key ? D() : "ArrowRight" === e.key && k();
      },
          I = function I(e, t) {
        a("pause" === e), m(!!t);
      },
          A = function A(e) {
        n(e), I("pause", !0);
      },
          D = function D() {
        A(function (e) {
          return e > 0 ? e - 1 : e;
        });
      },
          k = function k() {
        S ? T() : R();
      },
          T = function T() {
        A(function (e) {
          return (e + 1) % P.length;
        });
      },
          R = function R() {
        A(function (e) {
          return e < P.length - 1 ? e + 1 : e;
        });
      },
          z = function z(e) {
        e.preventDefault(), _.current = setTimeout(function () {
          I("pause");
        }, 200);
      },
          B = function B(e, t) {
        e.preventDefault(), _.current && clearTimeout(_.current), i ? I("play") : "next" === t ? k() : D();
      };

      return c.default.createElement("div", {
        style: Object.assign(Object.assign({}, h.container), {
          width: O,
          height: w
        })
      }, c.default.createElement(d.default.Provider, {
        value: {
          bufferAction: l,
          videoDuration: b,
          currentId: t,
          pause: i,
          next: k
        }
      }, c.default.createElement(p.default, null)), c.default.createElement(y.default, {
        action: I,
        bufferAction: l,
        playState: i,
        story: P[t],
        getVideoDuration: function getVideoDuration(e) {
          g(1e3 * e);
        }
      }), c.default.createElement("div", {
        style: h.overlay
      }, c.default.createElement("div", {
        style: {
          width: "50%",
          zIndex: 999
        },
        onTouchStart: z,
        onTouchEnd: function onTouchEnd(e) {
          return B(e, "previous");
        },
        onMouseDown: z,
        onMouseUp: function onMouseUp(e) {
          return B(e, "previous");
        }
      }), c.default.createElement("div", {
        style: {
          width: "50%",
          zIndex: 999
        },
        onTouchStart: z,
        onTouchEnd: function onTouchEnd(e) {
          return B(e, "next");
        },
        onMouseDown: z,
        onMouseUp: function onMouseUp(e) {
          return B(e, "next");
        }
      })));
    };

    var h = {
      container: {
        display: "flex",
        flexDirection: "column",
        background: "#111",
        position: "relative"
      },
      overlay: {
        position: "absolute",
        height: "inherit",
        width: "inherit",
        display: "flex"
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        i = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }
      return o(t, e), t;
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = i(n(0)),
        l = a(n(1)),
        c = {
      story: {
        display: "flex",
        position: "relative",
        overflow: "hidden",
        alignItems: "center"
      },
      storyContent: {
        width: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
        margin: "auto"
      }
    };

    t.default = function (e) {
      var t,
          n,
          r = u.useContext(l.default),
          o = r.width,
          i = r.height,
          a = r.loader,
          f = r.header,
          s = r.storyStyles,
          d = function d(t, n) {
        switch (t) {
          case "UPDATE_VIDEO_DURATION":
            return e.getVideoDuration(n.duration), {
              ack: "OK"
            };
        }
      };

      return u.default.createElement("div", {
        style: Object.assign(Object.assign({}, c.story), {
          width: o,
          height: i
        })
      }, (t = e.story.content, n = {
        width: o,
        height: i,
        loader: a,
        header: f,
        storyStyles: s
      }, u.default.createElement(t, {
        action: e.action,
        isPaused: e.playState,
        story: e.story,
        config: n,
        messageHandler: d
      })));
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function o(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        u = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && i(t, e, n);
      }
      return a(t, e), t;
    },
        l = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = u(n(0)),
        f = l(n(11)),
        s = l(n(3)),
        d = l(n(1)),
        y = l(n(2));

    t.default = function () {
      var e = r(c.useState(0), 2),
          t = e[0],
          n = e[1],
          o = c.useContext(s.default),
          i = o.currentId,
          a = o.next,
          u = o.videoDuration,
          l = o.pause,
          h = c.useContext(d.default),
          m = h.defaultInterval,
          v = h.onStoryEnd,
          b = h.onStoryStart,
          g = h.onAllStoriesEnd,
          _ = c.useContext(y.default).stories;
      c.useEffect(function () {
        n(0);
      }, [i, _]), c.useEffect(function () {
        return l || (j.current = requestAnimationFrame(w)), function () {
          cancelAnimationFrame(j.current);
        };
      }, [i, l]);

      var j = c.useRef(),
          O = t,
          w = function e() {
        0 === O && S(), n(function (e) {
          var t = E();
          return O = e + 100 / (t / 1e3 * 60), e + 100 / (t / 1e3 * 60);
        }), O < 100 ? j.current = requestAnimationFrame(e) : (x(), i === _.length - 1 && M(), cancelAnimationFrame(j.current), a());
      },
          S = function S() {
        b && b(i, _[i]);
      },
          x = function x() {
        v && v(i, _[i]);
      },
          M = function M() {
        g && g(i, _);
      },
          E = function E() {
        return "video" === _[i].type ? u : "number" == typeof _[i].duration ? _[i].duration : m;
      };

      return c.default.createElement("div", {
        style: p.progressArr
      }, _.map(function (e, n) {
        return c.default.createElement(f.default, {
          key: n,
          count: t,
          width: 1 / _.length,
          active: n === i ? 1 : n < i ? 2 : 0
        });
      }));
    };

    var p = {
      progressArr: {
        display: "flex",
        justifyContent: "center",
        maxWidth: "100%",
        flexWrap: "row",
        position: "absolute",
        width: "98%",
        padding: 5,
        paddingTop: 7,
        alignSelf: "center",
        zIndex: 99,
        filter: "drop-shadow(0 1px 8px #222)"
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        i = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }
      return o(t, e), t;
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = i(n(0)),
        l = a(n(12)),
        c = a(n(3));

    t.default = function (e) {
      var t = u.useContext(c.default),
          n = t.bufferAction,
          r = t.pause,
          o = e.width,
          i = e.active;
      return u.default.createElement(l.default, {
        width: o,
        pause: r,
        bufferAction: n
      }, u.default.createElement("div", {
        style: Object.assign(Object.assign({}, function (t) {
          switch (t.active) {
            case 2:
              return {
                width: "100%"
              };

            case 1:
              return {
                transform: "scaleX(".concat(e.count / 100, ")")
              };

            case 0:
            default:
              return {
                width: 0
              };
          }
        }({
          active: i
        })), f.inner)
      }));
    };

    var f = {
      inner: {
        background: "#fff",
        height: "100%",
        maxWidth: "100%",
        borderRadius: 2,
        transformOrigin: "center left",
        WebkitBackfaceVisibility: "hidden",
        MozBackfaceVisibility: "hidden",
        msBackfaceVisibility: "hidden",
        backfaceVisibility: "hidden",
        WebkitPerspective: 1e3,
        MozPerspective: 1e3,
        msPerspective: 1e3,
        perspective: 1e3
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(n(0)),
        i = function i(e) {
      var t = e.width,
          n = e.pause,
          r = e.bufferAction;
      return {
        width: "".concat(100 * t, "%"),
        opacity: n && !r ? 0 : 1
      };
    },
        a = {
      progress: {
        height: 2,
        maxWidth: "100%",
        background: "#555",
        margin: 2,
        borderRadius: 2,
        transition: "opacity 400ms ease-in-out"
      }
    };

    t.default = function (e) {
      return o.default.createElement("div", {
        style: Object.assign(Object.assign({}, a.progress), i(e))
      }, e.children);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getRenderer = void 0, t.getRenderer = function (e, t) {
      var n = t.map(function (t) {
        return Object.assign(Object.assign({}, t), {
          testerResult: t.tester(e)
        });
      }).filter(function (e) {
        return e.testerResult.condition;
      });
      return n.sort(function (e, t) {
        return t.testerResult.priority - e.testerResult.priority;
      }), n[0].renderer;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.renderers = void 0;
    var o = r(n(15)),
        i = r(n(21)),
        a = r(n(22)),
        u = r(n(23));
    t.renderers = [o.default, i.default, u.default, a.default];
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function o(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        u = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && i(t, e, n);
      }
      return a(t, e), t;
    },
        l = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tester = t.renderer = void 0;
    var c = u(n(0)),
        f = l(n(6)),
        s = l(n(4)),
        d = l(n(5));

    t.renderer = function (e) {
      var t = e.story,
          n = e.action,
          o = (e.isPaused, e.config),
          i = r(c.useState(!1), 2),
          a = i[0],
          u = i[1],
          l = o.width,
          p = o.height,
          h = o.loader,
          m = o.storyStyles,
          v = Object.assign(Object.assign({}, y.storyContent), m || {});
      return c.createElement(s.default, {
        story: t,
        globalHeader: o.header
      }, c.createElement(d.default, {
        story: t,
        action: n
      }, c.createElement("div", null, c.createElement("img", {
        style: v,
        src: t.url,
        onLoad: function onLoad() {
          u(!0), n("play");
        }
      }), !a && c.createElement("div", {
        style: {
          width: l,
          height: p,
          position: "absolute",
          left: 0,
          top: 0,
          background: "rgba(0, 0, 0, 0.9)",
          zIndex: 9,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#ccc"
        }
      }, h || c.createElement("div", {
        className: f.default.spinner
      })))));
    };

    var y = {
      story: {
        display: "flex",
        position: "relative",
        overflow: "hidden"
      },
      storyContent: {
        width: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
        margin: "auto"
      }
    };
    t.tester = function (e) {
      return {
        condition: !(e.content || e.type && "image" !== e.type),
        priority: 2
      };
    }, t.default = {
      renderer: t.renderer,
      tester: t.tester
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o = function o() {
      return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
    },
        i = function () {
      var e = {};
      return function (t) {
        if (void 0 === e[t]) {
          var n = document.querySelector(t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        a = [];

    function u(e) {
      for (var t = -1, n = 0; n < a.length; n++) {
        if (a[n].identifier === e) {
          t = n;
          break;
        }
      }

      return t;
    }

    function l(e, t) {
      for (var n = {}, r = [], o = 0; o < e.length; o++) {
        var i = e[o],
            l = t.base ? i[0] + t.base : i[0],
            c = n[l] || 0,
            f = "".concat(l, " ").concat(c);
        n[l] = c + 1;
        var s = u(f),
            d = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        -1 !== s ? (a[s].references++, a[s].updater(d)) : a.push({
          identifier: f,
          updater: m(d, t),
          references: 1
        }), r.push(f);
      }

      return r;
    }

    function c(e) {
      var t = document.createElement("style"),
          r = e.attributes || {};

      if (void 0 === r.nonce) {
        var o = n.nc;
        o && (r.nonce = o);
      }

      if (Object.keys(r).forEach(function (e) {
        t.setAttribute(e, r[e]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var a = i(e.insert || "head");
        if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        a.appendChild(t);
      }
      return t;
    }

    var f,
        s = (f = [], function (e, t) {
      return f[e] = t, f.filter(Boolean).join("\n");
    });

    function d(e, t, n, r) {
      var o = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
      if (e.styleSheet) e.styleSheet.cssText = s(t, o);else {
        var i = document.createTextNode(o),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }

    function y(e, t, n) {
      var r = n.css,
          o = n.media,
          i = n.sourceMap;
      if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), i && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }

    var p = null,
        h = 0;

    function m(e, t) {
      var n, r, o;

      if (t.singleton) {
        var i = h++;
        n = p || (p = c(t)), r = d.bind(null, n, i, !1), o = d.bind(null, n, i, !0);
      } else n = c(t), r = y.bind(null, n, t), o = function o() {
        !function (e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o());
      var n = l(e = e || [], t);
      return function (e) {
        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
          for (var r = 0; r < n.length; r++) {
            var o = u(n[r]);
            a[o].references--;
          }

          for (var i = l(e, t), c = 0; c < n.length; c++) {
            var f = u(n[c]);
            0 === a[f].references && (a[f].updater(), a.splice(f, 1));
          }

          n = i;
        }
      };
    };
  }, function (e, t, n) {
    (t = n(18)(!1)).push([e.i, "._1CK7FHVwhiOnuCiZJwiPq1 {\n\twidth: 40px;\n\theight: 40px;\n\tmargin: 100px auto;\n\tbackground-color: #fff;\n\n\tborder-radius: 100%;\n\t-webkit-animation: _1hEQ2VzIkTiZ-9jZoLI3JC 1s infinite ease-in-out;\n\tanimation: _1hEQ2VzIkTiZ-9jZoLI3JC 1s infinite ease-in-out;\n}\n\n@-webkit-keyframes _1hEQ2VzIkTiZ-9jZoLI3JC {\n\t0% {\n\t\t-webkit-transform: scale(0);\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\topacity: 0;\n\t}\n}\n\n@keyframes _1hEQ2VzIkTiZ-9jZoLI3JC {\n\t0% {\n\t\t-webkit-transform: scale(0);\n\t\ttransform: scale(0);\n\t}\n\t100% {\n\t\t-webkit-transform: scale(1);\n\t\ttransform: scale(1);\n\t\topacity: 0;\n\t}\n}\n", ""]), t.locals = {
      spinner: "_1CK7FHVwhiOnuCiZJwiPq1",
      "sk-scaleout": "_1hEQ2VzIkTiZ-9jZoLI3JC"
    }, e.exports = t;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var o = (a = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(a)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(l, " */")),
                  i = r.sources.map(function (e) {
                return "/*# sourceURL=".concat(r.sourceRoot || "").concat(e, " */");
              });
              return [n].concat(i).concat([o]).join("\n");
            }

            var a, u, l;
            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n, r) {
        "string" == typeof e && (e = [[null, e, ""]]);
        var o = {};
        if (r) for (var i = 0; i < this.length; i++) {
          var a = this[i][0];
          null != a && (o[a] = !0);
        }

        for (var u = 0; u < e.length; u++) {
          var l = [].concat(e[u]);
          r && o[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), t.push(l));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0)),
        i = {
      main: {
        display: "flex",
        alignItems: "center"
      },
      img: {
        width: 40,
        height: 40,
        borderRadius: 40,
        marginRight: 10,
        filter: "drop-shadow(0 0px 2px rgba(0, 0, 0, 0.5))",
        border: "2px solid rgba(255, 255, 255, 0.8)"
      },
      text: {
        display: "flex",
        flexDirection: "column",
        filter: "drop-shadow(0 0px 3px rgba(0, 0, 0, 0.9))"
      },
      heading: {
        fontSize: "1rem",
        color: "rgba(255, 255, 255, 0.9)",
        margin: 0,
        marginBottom: 2
      },
      subheading: {
        fontSize: "0.6rem",
        color: "rgba(255, 255, 255, 0.8)",
        margin: 0
      }
    };

    t.default = function (e) {
      var t = e.profileImage,
          n = e.heading,
          r = e.subheading;
      return o.default.createElement("div", {
        style: i.main
      }, t && o.default.createElement("img", {
        style: i.img,
        src: t
      }), o.default.createElement("span", {
        style: i.text
      }, o.default.createElement("p", {
        style: i.heading
      }, n), o.default.createElement("p", {
        style: i.subheading
      }, r)));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        i = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }
      return o(t, e), t;
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = i(n(0)),
        l = a(n(1));

    t.default = function (e) {
      var t = e.seeMoreContent,
          n = e.customCollapsed,
          r = u.useContext(l.default).keyboardNavigation;
      u.useEffect(function () {
        if ("undefined" != typeof window && window.document && "boolean" == typeof r && r) return document.addEventListener("keydown", o), function () {
          document.removeEventListener("keydown", o);
        };
      }, [r]);

      var o = function o(t) {
        "ArrowUp" === t.key ? (t.preventDefault(), e.toggleMore(!0)) : "ArrowDown" !== t.key && "Escape" !== t.key || (t.preventDefault(), e.toggleMore(!1));
      };

      return e.showContent ? u.default.createElement("div", {
        style: c.seeMoreExpanded
      }, u.default.createElement(t, {
        close: function close() {
          return e.toggleMore(!1);
        }
      })) : n ? u.default.createElement(n, {
        action: e.action,
        toggleMore: e.toggleMore
      }) : u.default.createElement("div", {
        style: c.seeMore,
        onClick: function onClick(t) {
          t.preventDefault(), t.stopPropagation(), e.toggleMore(!0);
        }
      }, u.default.createElement("span", {
        style: c.seeMoreIcon
      }, "⌃"), u.default.createElement("span", {
        style: c.seeMoreText
      }, "See more"));
    };

    var c = {
      seeMore: {
        height: "10vh",
        background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2))",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-end",
        bottom: 0
      },
      seeMoreExpanded: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        zIndex: 99999
      },
      seeMoreText: {
        color: "white",
        textAlign: "center",
        letterSpacing: "0.1em",
        marginBottom: "2.2vh",
        textTransform: "capitalize",
        opacity: "1",
        fontSize: "0.8em",
        transition: "opacity 300ms ease-in-out"
      },
      seeMoreIcon: {
        color: "white",
        textAlign: "center",
        letterSpacing: "0.2em",
        marginBottom: "0.4vh",
        opacity: "1",
        filter: "drop-shadow(0 0 5px black)",
        textTransform: "capitalize",
        transition: "opacity 300ms ease-in-out"
      },
      seeMoreClose: {
        position: "absolute",
        filter: "drop-shadow(0 3px 2px #ccc)",
        right: "0.5rem",
        top: "0.5rem",
        fontSize: "1.5rem",
        opacity: "0.7",
        padding: "1rem"
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function o(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        u = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && i(t, e, n);
      }
      return a(t, e), t;
    },
        l = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tester = t.renderer = void 0;
    var c = u(n(0)),
        f = l(n(6)),
        s = l(n(4)),
        d = l(n(5));

    t.renderer = function (e) {
      var t = e.story,
          n = e.action,
          o = e.isPaused,
          i = e.config,
          a = e.messageHandler,
          u = r(c.useState(!1), 2),
          l = u[0],
          p = u[1],
          h = r(c.useState(!1), 2),
          m = h[0],
          v = h[1],
          b = i.width,
          g = i.height,
          _ = i.loader,
          j = i.storyStyles,
          O = Object.assign(Object.assign({}, y.storyContent), j || {}),
          w = c.useRef(null);
      c.useEffect(function () {
        w.current && (o ? w.current.pause() : w.current.play().catch(function () {}));
      }, [o]);
      return c.createElement(s.default, {
        story: t,
        globalHeader: i.header
      }, c.createElement(d.default, {
        story: t,
        action: n
      }, c.createElement("div", {
        style: y.videoContainer
      }, c.createElement("video", {
        ref: w,
        style: O,
        src: t.url,
        controls: !1,
        onLoadedData: function onLoadedData() {
          a("UPDATE_VIDEO_DURATION", {
            duration: w.current.duration
          }), p(!0), w.current.play().then(function () {
            n("play");
          }).catch(function () {
            v(!0), w.current.play().finally(function () {
              n("play");
            });
          });
        },
        playsInline: !0,
        onWaiting: function onWaiting() {
          n("pause", !0);
        },
        onPlaying: function onPlaying() {
          n("play", !0);
        },
        muted: m,
        autoPlay: !0,
        "webkit-playsinline": !0
      }), !l && c.createElement("div", {
        style: {
          width: b,
          height: g,
          position: "absolute",
          left: 0,
          top: 0,
          background: "rgba(0, 0, 0, 0.9)",
          zIndex: 9,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#ccc"
        }
      }, _ || c.createElement("div", {
        className: f.default.spinner
      })))));
    };

    var y = {
      storyContent: {
        width: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
        margin: "auto"
      },
      videoContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    };
    t.tester = function (e) {
      return {
        condition: "video" === e.type,
        priority: 2
      };
    }, t.default = {
      renderer: t.renderer,
      tester: t.tester
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        i = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }
      return o(t, e), t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tester = t.renderer = void 0;
    var a = i(n(0));

    t.renderer = function (e) {
      var t = e.story,
          n = e.action;
      return a.useEffect(function () {
        n("play");
      }, [t]), a.createElement("div", {
        style: u.storyContent
      }, a.createElement("p", {
        style: u.text
      }, "This story could not be loaded."));
    };

    var u = {
      storyContent: {
        width: "100%",
        maxHeight: "100%",
        margin: "auto"
      },
      text: {
        textAlign: "center",
        color: "white",
        width: "90%",
        margin: "auto"
      }
    };
    t.tester = function () {
      return {
        condition: !0,
        priority: 1
      };
    }, t.default = {
      renderer: t.renderer,
      tester: t.tester
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, {
        enumerable: !0,
        get: function get() {
          return t[n];
        }
      });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
        i = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }
      return o(t, e), t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tester = t.renderer = void 0;
    var a = i(n(0));
    t.renderer = function (e) {
      a.useEffect(function () {
        e.action("play");
      }, [e.story]);
      var t = e.story.originalContent;
      return a.createElement(t, Object.assign({}, e));
    }, t.tester = function (e) {
      return {
        condition: !!e.content,
        priority: 2
      };
    }, t.default = {
      renderer: t.renderer,
      tester: t.tester
    };
  }]);
});